document.addEventListener('DOMContentLoaded', () => {
  const coverageChecker = document.getElementById('coverage-checker');
  const coverageCheckerLoader = document.getElementById('coverage-checker-loader');

  const coverageCheckerNextButton = document.getElementById('coverage-checker-next-button');
  const coverageCheckerSubmitButton = document.getElementById('coverage-checker-submit-button');

  coverageCheckerNextButton.addEventListener('click', () => {
    const coverageCheckerAddressInput = document.getElementById('coverage-checker-step-one-address-input');
    const coverageCheckerAddressValue = coverageCheckerAddressInput.value.trim();

    if (coverageCheckerAddressValue.length < 1) {
      Toastify({
        text: "Please enter an address",
        duration: 3000,
        newWindow: true,
        gravity: "top",
        position: "center",
        style: {
          background: 'red',
          color: 'white'
        },
      }).showToast();

      coverageCheckerAddressInput.scrollIntoView({ block: 'center' });
      coverageCheckerAddressInput.focus();
      return;
    }

    const checkCoveragePopupStepOne = document.getElementById('coverage-checker-step-one');
    const checkCoveragePopupStepTwo = document.getElementById('coverage-checker-step-two');
    checkCoveragePopupStepOne.style.display = 'none';
    checkCoveragePopupStepTwo.style.display = 'flex';

    coverageCheckerNextButton.style.display = 'none';
    coverageCheckerSubmitButton.style.display = 'flex';
  })

  const coverageCheckerForm = document.getElementById('coverage-checker-form');
  coverageCheckerForm.addEventListener('submit', async (e) => {
    e.preventDefault();

    const coverageCheckerFormFirstNameField = document.getElementById('coverage-checker-form-first-name-field');
    const coverageCheckerFormLastNameField = document.getElementById('coverage-checker-form-last-name-field');
    const coverageCheckerFormEmailField = document.getElementById('coverage-checker-form-email-field');

    const formData = new FormData(coverageCheckerForm);
    const data = Object.fromEntries(formData.entries());

    if (data['first-name'].trim().length == 0) {
      Toastify({
        text: "First name cannot be blank",
        duration: 3000,
        newWindow: true,
        gravity: "top",
        position: "center",
        style: {
          background: 'red',
          color: 'white'
        },
      }).showToast();

      coverageCheckerFormFirstNameField.value = ''
      coverageCheckerFormFirstNameField.scrollIntoView();
      coverageCheckerFormFirstNameField.focus();

      return;
    }

    if (data['last-name'].trim().length == 0) {
      Toastify({
        text: "Last name cannot be blank",
        duration: 3000,
        newWindow: true,
        gravity: "top",
        position: "center",
        style: {
          background: 'red',
          color: 'white'
        },
      }).showToast();

      coverageCheckerFormLastNameField.value = ''
      coverageCheckerFormLastNameField.scrollIntoView();
      coverageCheckerFormLastNameField.focus();

      return;
    }

    if (!validateEmail(data.email)) {
      Toastify({
        text: "Please enter a valid email address",
        duration: 3000,
        newWindow: true,
        gravity: "top",
        position: "center",
        style: {
          background: 'red',
          color: 'white'
        },
      }).showToast();

      coverageCheckerFormEmailField.scrollIntoView();
      coverageCheckerFormEmailField.focus();

      return;
    }

    coverageCheckerLoader.style.display = 'flex';

    const parsedAddress = parseAddress(data.address);
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(
      2,
      '0'
    )}-${String(currentDate.getDate()).padStart(2, '0')}`;

    let payload = {
      first_name: data['first-name'].trim(),
      last_name: data['last-name'].trim(),
      email: data.email,
      phone: data.phone,
      address1: parsedAddress.street,
      city: parsedAddress.city,
      state_code: parsedAddress.zip,
    };

    let r = await fetch('https://app.lrlos.com/webhook/Coverage-Page-Update-Nomad', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    payload = {
      status: 'new',
      partner_id: 3,
      location_id: 2,
      name: payload.first_name + ' ' + payload.last_name,
      email: payload.email,
      phone: payload.phone,
      category: 'person',
      street_1: parsedAddress.street,
      zip_code: parsedAddress.zip,
      city: parsedAddress.city,
      date_add: formattedDate,
    };

    coverageCheckerLoader.style.display = 'none';

    if (r.status === 200) {
      const coverageCheckerHeader = document.getElementById('coverage-checker-header');
      coverageCheckerHeader.style.display = 'none';
      coverageCheckerForm.style.display = 'none'

      const coverageCheckerSuccess = document.getElementById('coverage-checker-success');
      coverageCheckerSuccess.style.display = 'flex';
    } else {
      Toastify({
        text: "An error occurred. Please try again",
        duration: 3000,
        newWindow: true,
        gravity: "top",
        position: "center",
        style: {
          background: 'red',
          color: 'white'
        },
      }).showToast();
    }
  })

  const coverageCheckerFormPhoneField = document.getElementById('coverage-checker-form-phone-field');
  coverageCheckerFormPhoneField.addEventListener('keypress', (e) => {
    if (e.keyCode > 47 && e.keyCode < 58) {
      setTimeout(() => {
        let inputValue = e.target.value.replace(/\D/g, '');

        if (inputValue.length == 0) {
          inputStr = inputStr;
        } else if (inputValue.length < 4) {
          inputValue = '(' + inputValue;
        } else if (inputValue.length < 7) {
          inputValue = '(' + inputValue.substring(0, 3) + ') ' + inputValue.substring(3, 6);
        } else {
          inputValue =
            '(' + inputValue.substring(0, 3) + ') ' + inputValue.substring(3, 6) + '-' + inputValue.substring(6, 10);
        }

        e.target.value = inputValue;
      }, 100);
    } else {
      e.preventDefault();
    }
  })

  initAutoComplete('coverage-checker-step-one-address-input');
})
